import { render, staticRenderFns } from "./StepSettingsPanelProperties.vue?vue&type=template&id=524bce01&scoped=true&"
import script from "./StepSettingsPanelProperties.vue?vue&type=script&lang=js&"
export * from "./StepSettingsPanelProperties.vue?vue&type=script&lang=js&"
import style0 from "./StepSettingsPanelProperties.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./StepSettingsPanelProperties.vue?vue&type=style&index=1&id=524bce01&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "524bce01",
  null
  
)

export default component.exports